var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isActive)?_c('ProjectInfo',{attrs:{"include-floorplan":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }